import React from 'react';

/**
 * EmptyState - Reusable empty state component
 * Shows a centered card with icon, title, description, and optional CTA button.
 * Supports both emoji strings and JSX icon components.
 *
 * @param {string|React.ReactNode} icon - Emoji string or icon component
 * @param {string} title - Main heading
 * @param {string} description - Descriptive text
 * @param {string} actionLabel - Optional button label
 * @param {function} onAction - Optional button click handler
 */
const EmptyState = ({ icon, title, description, actionLabel, onAction }) => {
  const isJSXIcon = typeof icon !== 'string' && icon != null;

  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 animate-fade-in-up">
      {icon && (
        isJSXIcon ? (
          <div className="w-16 h-16 rounded-full bg-indigo-50 flex items-center justify-center text-indigo-500 mb-4 animate-float">
            {icon}
          </div>
        ) : (
          <span className="text-5xl mb-4 animate-float">{icon}</span>
        )
      )}
      <h3 className="text-xl font-semibold text-gray-900 mb-2">{title}</h3>
      {description && (
        <p className="text-gray-500 text-center max-w-md mb-6">{description}</p>
      )}
      {actionLabel && onAction && (
        <button
          onClick={onAction}
          className="px-5 py-2.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 font-medium transition-colors"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
